import { Record } from 'immutable';
import { EventCollisionInfo } from './event-collision-info';
import { UnmatchEventPartyRequest } from './unmatch-event-party-request';

const UnmatchEventRequestRecord = Record({
  action: null,
  event_id: null,
  parties: null,
  reason: null,
  unmatched_by: null,
  party_initiator_type: null,
  party_initiator_code: null,
  event_info: null,
});

export class UnmatchEventRequest extends UnmatchEventRequestRecord {
  action: string;
  event_id: number;
  parties: UnmatchEventPartyRequest[];
  reason: string;
  unmatched_by: string;
  party_initiator_type: string;
  party_initiator_code: string;
  event_info: EventCollisionInfo[];
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/unmatch-event-request.ts